import BaseApiService from './api.base.service'

class BomApiService extends BaseApiService {
  constructor() {
    super('bom')
  }

  getTrackingInfo(bomTrackingParams) {
    return this.callPost('tracking/', {
      fromDate: bomTrackingParams.fromDate,
      toDate: bomTrackingParams.toDate,
      participantId: bomTrackingParams.participantId,
      courseId: bomTrackingParams.courseId,
      batchSize: bomTrackingParams.batchSize,
      nextAfterId: bomTrackingParams.nextAfterId,
    })
  }

  getEulotechTree() {
    return this.callGet('eulotech/tree')
  }

  getEulotechAssociations() {
    return this.callGet('eulotech/associations')
  }

  getBomTree() {
    return this.callGet('theme-areas/tree')
  }

  getBomAssociations() {
    return this.callGet('theme-areas/associations')
  }

  createBomEulotechAssociation(bomEulotechAssociation) {
    return this.callPost('associations/create', {
      eulotechNodeId: bomEulotechAssociation.eulotechNodeId,
      bomNodeId: bomEulotechAssociation.bomNodeId,
    })
  }

  deleteBomEulotechAssociation(bomEulotechAssociation) {
    return this.callPost('associations/delete', {
      eulotechNodeId: bomEulotechAssociation.eulotechNodeId,
      bomNodeId: bomEulotechAssociation.bomNodeId,
    })
  }
}

export const bomApi = new BomApiService()
